import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useEGCart } from "../../../../contexts/EGcartContext";
import { useLoading } from "../../../../hooks/useLoader";
import "./PaymentSuccess.css";
import { Button } from "@mui/material";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { useAuth } from "../../../../hooks/useAuth";
const RenderButtons = ({ cartItems, handleGoToCart, handleContinueShopping }) => {
  return (
    <>
      {cartItems?.length > 0 && (
        <Button
          startIcon={<ShoppingCartOutlinedIcon />}
          onClick={handleGoToCart}
          variant="outlined"
        >
          GO TO CART
        </Button>
      )}
      <Button
        onClick={handleContinueShopping}
        variant="contained"
      >
        CONTINUE
      </Button>
    </>
  );
};

RenderButtons.propTypes = {
  cartItems: PropTypes.array.isRequired,
  handleGoToCart: PropTypes.func.isRequired,
  handleContinueShopping: PropTypes.func.isRequired,
};

const EGPaymentSuccess = () => {
  const history = useHistory();
  const { cart, getCartDetails } = useEGCart();
  const auth = useAuth();
  const { showLoader } = useLoading();
  const [cartItems, setCartItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const refreshCart = async () => {
      try {
        setIsLoading(true);
        showLoader(true);
        const result = await getCartDetails();
        
        if (result?.success) {
          const items = result.data || [];
          console.log("Cart items loaded:", items.length, "items");
          setCartItems(items);
        } else {
          console.warn("Cart fetch unsuccessful:", result?.error || "No success property");
          setCartItems([]);
        }
      } catch (error) {
        console.error("Error fetching cart details:", error);
        console.error("Error stack:", error.stack);
      } finally {
        showLoader(false);
        setIsLoading(false);
      }
    };
    const timer = setTimeout(() => {
      console.log("setTimeout callback executed");
      refreshCart();
    }, 100);
    return () => clearTimeout(timer);
  }, [getCartDetails, showLoader]);


  const handleContinueShopping = () => {
    const id = auth.getCurrentUser()?.userId;
    if (id) {
      history.push(`/enterprisegroup/${id}/add-ins`);
    }else{
      history.push(`/enterprisegroup`);
    }
    
  };

const handleGoToCart = () => {
  history.push("/cart/checkout");
};

const renderSuccessMessage = () => {
    const itemsToCheck = cartItems.length > 0 ? cartItems : cart;

    if (itemsToCheck.length > 0) {
      // Scenario B - Pending items exist in cart
      return (
        <p className="success-message eg-success-message">
          You still have items pending in your cart.
        </p>
      );
    }

    // Scenario A - No pending items in cart
    return (
      <p className="success-message eg-success-message">
       Click CONTINUE to return to the Add-ins list.
      </p>
    );
  };

  
  const renderConfigurationInstruction = () => (
    <p className="success-message eg-success-message eg-settings-instruction">
      <span>
        To configure your purchased Add-in, please click on the Settings icon.
      </span>
    </p>
  );


  if (isLoading) {
    return (
      <div className="payment-success-container eg-payment-success-container">
        <div className="payment-success-content eg-payment-success-content">
          <p className="success-message eg-success-message">Loading details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-container eg-payment-success-container">
      <div className="payment-success-content eg-payment-success-content">
        <div className="success-icon-wrapper">
          <CheckCircleOutlineIcon className="success-icon" />
        </div>
        <h1>Your order has been purchased!</h1>
        {renderSuccessMessage()}
        {renderConfigurationInstruction()}
        <div className="success-buttons">
          <RenderButtons 
            cartItems={cartItems}
            handleGoToCart={handleGoToCart}
            handleContinueShopping={handleContinueShopping}
          />
        </div>
      </div>
    </div>
  );
};

export default EGPaymentSuccess;
